import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandSVG = (
  <svg fill="none" viewBox="0 0 24 19" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M14.3304 1.28434c2.5312-1.99892 6.1543-1.617188 8.2185.81531l.1557.19116.1475.19693c1.8084 2.5194 1.3808 6.02667-.9887 8.04226l-.1964.1601-2.8695 2.2403-6.8019 5.4055-9.69331-7.5732C-.238883 8.77728-.740071 5.1478 1.11721 2.56031l.14753-.19694c2.0333-2.602508 5.76294-3.036866 8.34687-.9569l2.25889 1.81889 2.4599-1.94102z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: CrossBrandSVG,
  [Brands.BananaRepublic]: CrossBrandSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
  [Brands.Gap]: CrossBrandSVG,
  [Brands.GapFactoryStore]: CrossBrandSVG,
  [Brands.OldNavy]: CrossBrandSVG,
  crossBrand: CrossBrandSVG,
};

export const HeartIcon = (props: IconContainerProps): JSX.Element => (
  <Icon {...props} brandIconSVGs={brandIconSVGs} />
);
